import { defineStore } from "pinia";
import { ref } from "vue";

export const useProcedureCreateStore = defineStore('procedureCreate', () => {
    const isPositionsRequired = ref(false);

    function setPositionsRequired(value) {
        isPositionsRequired.value = value;
    }

    return {
        isPositionsRequired,
        setPositionsRequired,
    }
});
